module.exports = __webpack_public_path__ + "static/media/mp-formas-pagamento.7a46787b.png";